<template>
    <div class="similar-interesting-header">
        <button
            type="button"
            class="similar-interesting-header__tab"
            :class="{ 'similar-interesting-header__tab_active': activeTab === '#nav-home', 'delimiter': issetTabs.interesting }"
            @click="$emit('changeTab', '#nav-home')"
            v-if="issetTabs.similar"
        >
            {{titles.similar}}
        </button>
        <button
            type="button"
            class="similar-interesting-header__tab"
            :class="{ 'similar-interesting-header__tab_active': activeTab === '#nav-profile' }"
            @click="$emit('changeTab', '#nav-profile')"
            v-if="issetTabs.interesting"
        >
            {{titles.interesting}}
        </button>
    </div>
</template>

<script>
export default {
    name: 'SimilarInterestingHeader',
    select: '.similar-interesting-header',
    props: ['activeTab', 'titles', 'issetTabs']
}
</script>

<style lang="scss" scoped>
.similar-interesting-header{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 23px;
    &__tab{
        color: #7B7C7E;
        //font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
        border: none;
        background-color: transparent;
        padding: 0 40px;
        cursor: pointer;
        transition: .2s linear color;
        &_active{
            color: #333;
            //font-size: 24px;
        }
    }
}
.delimiter{
  position: relative;
  &:after{
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #3C3D41;
  }
}
</style>